const TIME_OUT = 200000;
const APP_ID = "1017061410";
// const SERVER = 'http://linyao.wicp.net/api'
// const SERVER = 'http://172.23.10.155/api'
const LOGIN_OUT = "http://cro.test.yunzhangfang.com/tiwc/?v=003";

// const SERVER = 'http://newcro.yunzhangfang.com/api'
// const LOGIN_OUT = 'http://newcro.yunzhangfang.com/tiwc/#/login'

const SERVER = "http://cro.yunzhangfang.com/api";
// const LOGIN_OUT = 'http://cro.yunzhangfang.com/tiwc/?v=005'

export { SERVER, TIME_OUT, LOGIN_OUT, APP_ID };



// WEBPACK FOOTER //
// ./src/config/app.js